import { render, staticRenderFns } from "./ListComponent.vue?vue&type=template&id=b55018be&scoped=true"
import script from "./ListComponent.vue?vue&type=script&lang=js"
export * from "./ListComponent.vue?vue&type=script&lang=js"
import style0 from "./ListComponent.vue?vue&type=style&index=0&id=b55018be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55018be",
  null
  
)

export default component.exports